<script>
import Vue from 'vue';
import { VueFinalModal } from 'vue-final-modal'
import PasstypeRestrictionDates from '../../components/passtype-restriction-dates/PasstypeRestrictionDates.vue';

export default {
    props: {
        passes: {
            type: String,
            default: '',
            required: true
        },
        selectedPass: {
            type: String,
            default: '',
            required: false
        },
        useInvertedDates: {
            type: Boolean,
            default: false,
            required: true
        },
        closeModalText: {
            type: String,
            default: 'Close',
            required: true
        }     
    },
    emits: ['confirm'],
    components: {
        'passtype-restrictions-dates': PasstypeRestrictionDates
    },
    methods: {
        closeModal(e) {
            this.$root.$emit('confirm', e)
        },
    },
    template: `
        <VueFinalModal>
            <dialog class="v-modal">
                <div class="v-modal__backdrop"></div>
                <div class="v-modal__inner">
                    <div class="v-modal__holder">
                        <div class="v-modal__content">
                            <div class="box">
                                <button class="close-modal" type="button" @click="closeModal">
                                    <span class="visuallyhidden">{{ closeModalText }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                                        <path fill="currentColor" d="M23.772 8.228a1 1 0 010 1.414l-6.364 6.364 6.364 6.364a1 1 0 01-1.414 1.414l-6.364-6.364-6.364 6.364a1 1 0 01-1.414-1.414l6.364-6.365-6.364-6.363A1 1 0 019.63 8.228l6.365 6.363 6.363-6.363a1 1 0 011.414 0z"></path>
                                    </svg>
                                </button>
                                <passtype-restrictions-dates v-bind="$props" />
                            </div>
                        </div>
                    </div>
                </div>
            </dialog>
        </VueFinalModal>`
};
</script>